import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc mẫu ca
export function locMauCa(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/mau-ca/', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy mẫu ca
export function layMauCa(id: number) {
  try {
    return axiosApi.get('/cham-cong/mau-ca/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo mẫu ca
export function taoMauCa(params: any) {
  try {
    return axiosApi.post('/cham-cong/mau-ca/', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật mẫu ca
export function capNhatMauCa(id: number, params: any) {
  try {
    return axiosApi.put('/cham-cong/mau-ca/' + id, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa mẫu ca
export function xoaMauCa(id: number) {
  try {
    return axiosApi.delete('/cham-cong/mau-ca/' + id)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Áp dụng mẫu ca
export function apDungMauCa(id: number, params: any) {
  try {
    return axiosApi.post('/cham-cong/mau-ca/' + id + '/ap-dung', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
